/* eslint-disable react/display-name */
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";

const NavigationListItem = (props) => {
  const {
    title,
    href,
    depth,
    children,
    className,
    code,
    isLastItem,
    open: openProp,
    label: Label,
    pageid,
    menuIcon,
    isMenuCollapse,
    ...rest
  } = props;

  const location = useLocation();
  const pathname = location.pathname;

  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((open) => !open);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = {
    paddingLeft,
  };

  if (children) {
    return (
      <>
        {/* Section Heading */}
        {isMenuCollapse && (
          <h2 className="font-13 font-weight-medium text-color mb-3">
            {title}
          </h2>
        )}
        {children}
      </>
    );
  } else {
    return (
      <>
        {/*  Link */}
        <Link to={href} className="text-decoration-none">
          <button
            className={`${
              pathname === "/" + href
                ? "activeTab-sideNav"
                : "InactiveTab-sideNav"
            } mb-3 d-flex align-items-center`}
            title={title}
          >
            <Image
              src={menuIcon}
              className={`me-2 ${!isMenuCollapse ? "mx-auto" : ""}`}
              alt={title}
            />
            {isMenuCollapse && <span className="sidebar-label">{title}</span>}
          </button>
        </Link>
      </>
    );
  }
};

NavigationListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavigationListItem.defaultProps = {
  depth: 0,
  open: false,
};

export default NavigationListItem;
